import { render } from "./RimborsoDetail.vue?vue&type=template&id=7bbc5412&scoped=true"
import script from "./RimborsoDetail.vue?vue&type=script&lang=js"
export * from "./RimborsoDetail.vue?vue&type=script&lang=js"

import "./RimborsoDetail.vue?vue&type=style&index=0&id=7bbc5412&scoped=true&lang=css"

import exportComponent from "/var/www/app_server_flask/temp/temp_app_ingegno_jecko_1764366014063414604/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bbc5412"]])

export default __exports__